import { useState } from 'react'
import type { LiveAiChatScope } from './ai-chat-live-content'
import { useIsDesktop } from '@/shared/hooks/useIsDesktop'
import { useLocalStorageBoolean } from '@/shared/hooks/useLocalStorageBoolean'

export function useAiChatPanelState({
  userId,
  workspaceId,
  scope,
}: {
  userId: string
  workspaceId: string
  scope: LiveAiChatScope
}) {
  const isDesktop = useIsDesktop()
  const prefix = `ai-chat:${userId}:${workspaceId}:${scope}`
  const { value: pinned, setValue: setPinned } = useLocalStorageBoolean({
    key: `${prefix}:pinned`,
    defaultValue: true,
  })
  const { value: visible, setValue: setVisible } = useLocalStorageBoolean({
    key: `${prefix}:visible`,
    defaultValue: true,
  })
  const [mobileOpen, setMobileOpen] = useState(false)
  const open = isDesktop ? visible : mobileOpen

  return {
    isDesktop,
    widthStorageKey: `${prefix}:width`,
    open,
    pinned: isDesktop && pinned,
    openChat: () => {
      if (isDesktop) setVisible(true)
      else setMobileOpen(true)
    },
    toggleChat: () => {
      if (isDesktop) setVisible((value) => !value)
      else setMobileOpen((value) => !value)
    },
    closeChat: () => {
      if (isDesktop) setVisible(false)
      else setMobileOpen(false)
    },
    togglePin: () => setPinned((value) => !value),
  }
}
